import styled from 'styled-components';
import { StyledOAuthContainer, StyledOAuthErrorMessage } from '../oauth/OAuthButton.styles';
import UIImage from 'UIComponents/image/UIImage';
import imageUrls from '../images/imageUrls';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Step } from 'signup-constants/Step';
import { useState } from 'react';
import { EERIE, GYPSUM } from 'HubStyleTokens/colors';
import { useDispatch } from 'react-redux';
import { updateKeyValue } from '../store/app/action-creators';
import { AppKey } from '../app/AppKey';
import { useTracker } from '../tracking/useTracker';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LinkedinBlue = '#2867b2';
const StyledLinkedinButton = styled.button.withConfig({
  displayName: "LinkedInButton__StyledLinkedinButton",
  componentId: "ejphyj-0"
})(["width:100%;min-height:36px;display:flex;border-radius:4px;background-color:", ";border:2px solid ", ";color:white;align-items:center;&:disabled{background-color:", " !important;border-color:", " !important;color:", " !important;cursor:not-allowed;div{background-color:", " !important;border-color:", " !important;}}"], LinkedinBlue, LinkedinBlue, EERIE, EERIE, GYPSUM, EERIE, EERIE);
const StyledLogo = styled.div.withConfig({
  displayName: "LinkedInButton__StyledLogo",
  componentId: "ejphyj-1"
})(["height:36px;width:36px;display:flex;justify-content:center;align-items:center;min-width:36px;.Image{height:auto;width:18px;}"]);
const StyledText = styled.div.withConfig({
  displayName: "LinkedInButton__StyledText",
  componentId: "ejphyj-2"
})(["display:flex;justify-content:center;align-items:center;width:100%;height:36px;font-size:14px;letter-spacing:0.25px;font-weight:500;min-width:160px;"]);
const OAUTH_LINKEDIN = 'linkedin';
const LinkedinButton = () => {
  const [shouldRenderError, setShouldRenderError] = useState(false);
  const dispatch = useDispatch();
  const Tracker = useTracker();
  const handleButtonClick = () => {
    Tracker.signupInteraction('click-oauth-button', {
      partner: OAUTH_LINKEDIN
    });
    dispatch(updateKeyValue(AppKey.FirstOAuthPartnerClick, OAUTH_LINKEDIN));
    setShouldRenderError(true);
  };
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(StyledOAuthContainer, {
      children: /*#__PURE__*/_jsxs(StyledLinkedinButton, {
        disabled: shouldRenderError,
        onClick: handleButtonClick,
        children: [/*#__PURE__*/_jsx(StyledLogo, {
          children: /*#__PURE__*/_jsx(UIImage, {
            alt: "Linkedin Logo",
            className: "Image",
            src: imageUrls.linkedinLogo
          })
        }), /*#__PURE__*/_jsx(StyledText, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `views.${Step.LandingPage}.acq0154signupWithLinkedin`
          })
        })]
      })
    }), shouldRenderError && /*#__PURE__*/_jsxs(StyledOAuthErrorMessage, {
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: `views.${Step.LandingPage}.linkedinError`
      }), /*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `views.${Step.LandingPage}.otherOAuths.linkedin`
        })
      })]
    })]
  });
};
export default LinkedinButton;